import { Component } from '@angular/core';
import {AlertController, Events, IonicPage, ModalController, NavController, NavParams} from 'ionic-angular';
import {ChallengeProvider} from "../../providers/challenge/challenge";
import {k} from "@angular/core/src/render3";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {AppChallengeUserPopupStartPage} from "../app-challenge-user-popup-start/app-challenge-user-popup-start";
import {
  AppChallengeUserPopupCompletionRequestPage
} from "../app-challenge-user-popup-completion-request/app-challenge-user-popup-completion-request";
import moment from 'moment';

/**
 * Generated class for the AppChallengeUserPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-challenge-user',
  templateUrl: 'app-challenge-user.html',
})
export class AppChallengeUserPage {

  lastClosedChallenge: number = 0;
  challengeData: Array<any> = [];
  challengeProcessStatus: number = null;
  currentlyOpenedChallenge: any = null;

  constructor(public navCtrl: NavController, public navParams: NavParams,  private challenge: ChallengeProvider, private alertCtrl: AlertController, private contentTranslation: ContentTranslationProvider, private modalCtrl: ModalController, private events: Events) {
    var suffix = 1;
    for (var i = 0; i < 32; i++) {
      var classes = [];
      if((i % 2) == 1) {
        classes.push('even');
      }
      if(i < 4) {
        classes.push('first-line');
      }
      if (i == 28 || i == 30) {
        suffix--;
      }
      if ([0,3,6,10,13,15,16,18,20,31].indexOf(i)>-1) {
        classes.push('gold');
      }
      this.challengeData[i] = {
        empty: (i == 28 || i == 30),
        num: i+suffix,
        class: classes.join(' ')
      }
    }
  }

  getKeyForChallengePosition(i) {
    if (i == 28) {
      return 29;
    }
    if (i == 29) {
      return 31;
    }
    return i;
  }

  proceedChallengeData() {
    let previousChallenge = null;
    this.currentlyOpenedChallenge = null;
    for (var challenge of this.challenge.getUserChallenges()) {
      let extraClass = '';
      if(challenge._userStatus > 0) {
        this.challengeProcessStatus = 1;
      }

      let key = this.getKeyForChallengePosition(challenge.position);
      if(!this.challengeData[key]) {
        continue;
      }
      this.challengeData[key].data = challenge;
      if(challenge._userStatus == 1) {
        extraClass = 'in-progress'
        this.checkForCompletion(challenge);
        this.currentlyOpenedChallenge = challenge;
      }
      if(challenge._userStatus == 2) {
        this.challengeData[key].image = challenge.imageURL;
      }
      this.challengeData[key].extraClass = extraClass;
      if (previousChallenge) {
        challenge.previousChallenge = previousChallenge;
      }
      previousChallenge = challenge;
    }
    console.log('user challenge data', this.challengeData);
    if(previousChallenge._userStatus == 2 || previousChallenge._userStatus == -1) {
      this.challengeProcessStatus = 3;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppChallengeUserPage');

    this.proceedChallengeData();
    this.events.subscribe('state:refreshed', () => {
      this.proceedChallengeData();
    })

  }
  handleChallengeClick(challenge) {
    if (!challenge.data) {
      return ;
    }
    console.log('challenge click', challenge);

    let previousChallenge = challenge.data.previousChallenge;
    if(previousChallenge && ([0,1].indexOf(previousChallenge._userStatus)>-1 || (previousChallenge._userStatus == 2 && previousChallenge._userLastProbe == moment().format('YYYY-MM-DD')))) {
      this.showLockedChallengePopup();
      return ;
    }

    if(challenge.data._userStatus == 1) {
      let modal = this.modalCtrl.create(AppChallengeUserPopupCompletionRequestPage, {challenge: challenge.data});
      modal.present();

      return ;
    }


    let modal = this.modalCtrl.create(AppChallengeUserPopupStartPage, {challenge});
    modal.present();
  }

  checkForCompletion(challenge) {
    console.log(challenge, new Date().toISOString().substr(0, 10))
    if (challenge._userLastProbe < new Date().toISOString().substr(0, 10)) {
      let modal = this.modalCtrl.create(AppChallengeUserPopupCompletionRequestPage, {challenge});
      modal.present();
    }
  }

  showInfoPopup() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Challenge 30 days info title'),
      subTitle: this.contentTranslation.translateContent('Challenge 30 days info description'),
      buttons: [
        {
          text: '×',
          cssClass: 'close-button'
        }
      ],
      cssClass: 'ip-alert ip-with-close ip-dynamic-height'
    });
    alert.present();
  }

  showLockedChallengePopup() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Challenge 30 not yet available title'),
      subTitle: this.contentTranslation.translateContent('Challenge 30 not yet available description'),
      buttons: [
        {
          text: '×',
          cssClass: 'close-button'
        }
      ],
      cssClass: 'ip-alert ip-with-close ip-dynamic-height'
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-user/app-challenge-user.ts